import React, { Component, Fragment } from 'react';
import { Card, Button } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import historyReportPdf from './HistoryReportFour';
import Spinner from 'react-bootstrap/Spinner';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

class HistoryFormFour extends Component {

    constructor(props) {
        super(props);
        this.state = {
            motivo_consulta: this.props.history.motivo_consulta != null && this.props.history.motivo_consulta != undefined ? this.props.history.motivo_consulta : null,
            recomendaciones: this.props.history.recomendaciones != null && this.props.history.recomendaciones != undefined ? this.props.history.recomendaciones : null,
            descripcion: "",
            observaciones: "",
            id_informe: "",
            age: '',
            plans: [],
            planName: '',
            idPlan: '',
            urlLogo: '',
            disableInput: false,
            exist: false,
            onUpdate: false,
            loading: true,
            useRecomentarions: true,
            encuesta_inventario: this.props.history.encuesta_inventario != null && this.props.history.encuesta_inventario != undefined ? this.props.history.encuesta_inventario : null,
            pruebas_equilibrio: this.props.history.pruebas_equilibrio != null && this.props.history.pruebas_equilibrio != undefined ? this.props.history.pruebas_equilibrio : null,
            nistagmo_espontanoeo: this.props.history.nistagmo_espontanoeo != null && this.props.history.nistagmo_espontanoeo != undefined ? this.props.history.nistagmo_espontanoeo : null,
            maniobra_hallpike: this.props.history.maniobra_hallpike != null && this.props.history.maniobra_hallpike != undefined ? this.props.history.maniobra_hallpike : null,
            test_agudeza: this.props.history.test_agudeza != null && this.props.history.test_agudeza != undefined ? this.props.history.test_agudeza : null,
            conclusion:this.props.history.conclusion != null && this.props.history.conclusion != undefined ? this.props.history.conclusion : null
        }
    }

    componentDidMount() {
        this.getDataHistory();
    }

    getDataHistory = () => {

        if (this.props.dataHistory.length > 0) {

            const data = this.props.dataHistory;

            for (let i = 0; i < data.length; i++) {
                if (data[i].tipo_informe === 6) {

                    this.setState({
                        loading: false,
                        id_informe: data[i].id_hist_informes,
                        motivo_consulta: data[i].motivo_consulta,
                        recomendaciones: data[i].recomendaciones,
                        descripcion: data[i].interpretacion,
                        observaciones: data[i].observacion,
                        exist: true,
                        disableInput: true,
                        useRecomentarions: data[i].recomendaciones === '' ? false : true,
                        encuesta_inventario: data[i].encuesta_inventario,
                        pruebas_equilibrio: data[i].pruebas_equilibrio,
                        nistagmo_espontanoeo: data[i].nistagmo_espontanoeo,
                        maniobra_hallpike: data[i].maniobra_hallpike,
                        test_agudeza: data[i].test_agudeza,
                        conclusion: data[i].conclusion
                    })
                } else if ((i + 1) === data.length) {
                    this.setState({ loading: false });
                }
            }
        } else {
            this.setState({ loading: false });
        }
    }



    generteReportPdf = async () => {

        const dataReport = {
            motivo_consulta: this.state.motivo_consulta,
            recomendaciones: this.state.recomendaciones,
            descripcion: this.state.descripcion,
            observaciones: this.state.observaciones,
            names: this.props.data.nombres,
            direccion: this.props.data.adress.direccion,
            age: this.props.age,//this.state.age,
            plan: this.props.planName, //this.state.planName,
            id_historia: this.props.data.id_historia,
            documentNumber: this.props.data.num_documento,
            ocupation: this.props.data.ocupacion !== null ? this.props.data.ocupacion : '',
            telephone: this.props.data.telephone,
            telephone: this.props.data.telephone !== null ? this.props.data.telephone : '',
            address: this.props.data.adress.direccion !== null ? this.props.data.adress.direccion : '',
            fecha: this.props.data.fecha,
            remitente: this.props.data.remitente,
            hora: this.props.data.fecha_ingreso_completa,
            useRecomentarions: this.state.useRecomentarions,
            encuesta_inventario: this.state.encuesta_inventario,
            pruebas_equilibrio: this.state.pruebas_equilibrio,
            nistagmo_espontanoeo: this.state.nistagmo_espontanoeo,
            maniobra_hallpike: this.state.maniobra_hallpike,
            test_agudeza: this.state.test_agudeza,
            conclusion: this.state.conclusion,
            recomendaciones: this.state.recomendaciones
        };

        historyReportPdf(dataReport);
    }

    saveData = () => {

        if (this.state.observaciones === '')
            this.setState({ observaciones: this.props.history.observaciones });

        //Descripcion - Interpretacion
        const dataToSend = {
            id_historia: this.props.data.id_historia,
            id_admision: this.props.data.id_admision,
            motivo_consulta: this.state.motivo_consulta,
            procedimiento: this.state.procedimiento,
            parametro_estimulacion: '',
            resultados: '',
            procedimiento: '',
            interpretacion: this.state.descripcion,
            observacion: this.state.observaciones,
            recomendaciones: this.state.recomendaciones,
            conclusion: this.state.conclusion,
            nota: "",
            fecha: this.props.data.fecha, //moment(new Date(this.props.data.fecha)).format("YYYY-MM-DD"),
            id_servicio: null,
            tipo_informe: 6,
            antecedentes_paciente: null,
            lengua_payne: null,
            observacion2: null,
            mioescanografia: null,
            encuesta_inventario: this.state.encuesta_inventario,
            pruebas_equilibrio: this.state.pruebas_equilibrio,
            nistagmo_espontanoeo: this.state.nistagmo_espontanoeo,
            maniobra_hallpike: this.state.maniobra_hallpike,
            test_agudeza: this.state.test_agudeza

        }

        console.log(dataToSend);

        
        fetch(process.env.REACT_APP_PUBLIC_URL + 'historia-informe/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataToSend)
        })
            .then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.text();
                }
            })
            .then(data => {
                console.log(data);
                this.generteReportPdf().then(() => {
                    //window.location.reload();
                    this.setState({ disableInput: true, exist: true });
                });

            })
            .catch((error) => {
                console.error('Error:', error);
                //reject(error)
            });
            
    }

    updateData = () => {

        //Descripcion - Interpretacion
        const dataToSend = {
            id_hist_informes: this.state.id_informe,
            id_historia: this.props.data.id_historia,
            id_admision: this.props.data.id_admision,
            motivo_consulta: this.state.motivo_consulta,
            procedimiento: this.state.procedimiento,
            parametro_estimulacion: '',
            resultados: '',
            procedimiento: '',
            interpretacion: this.state.descripcion,
            observacion: this.state.observaciones === '' ? this.props.history.observaciones : this.state.observaciones,
            recomendaciones: this.state.useRecomentarions ? this.state.recomendaciones : '',
            conclusion: this.state.conclusion,
            nota: "",
            fecha: this.props.data.fecha, //moment(new Date(this.props.data.fecha)).format("YYYY-MM-DD"),
            id_servicio: null,
            tipo_informe: 6,
            antecedentes_paciente: null,
            lengua_payne: null,
            observacion2: null,
            mioescanografia: null,
            encuesta_inventario: this.state.encuesta_inventario,
            pruebas_equilibrio: this.state.pruebas_equilibrio,
            nistagmo_espontanoeo: this.state.nistagmo_espontanoeo,
            maniobra_hallpike: this.state.maniobra_hallpike,
            test_agudeza: this.state.test_agudeza

        }

        fetch(process.env.REACT_APP_PUBLIC_URL + 'historia-informe/update', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataToSend)
        })
            .then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.text();
                }
            })
            .then(data => {
                console.log(data);
                this.generteReportPdf().then(() => {
                    //window.location.reload();
                    this.setState({ disableInput: true, exist: true, onUpdate: false });
                });

            })
            .catch((error) => {
                console.error('Error:', error);
                //reject(error)
            });
    }


    render() {

        return (
            <Card>
                {this.state.loading ?
                    <div className="text-center">
                        <Spinner animation="border" variant="success" />
                    </div>
                    :
                    <Fragment>
                        <div className="form" style={{ flex: 1, flexDirection: 'column', display: 'flex' }}>
                            <div className="card__title">
                                <h5 className="bold-text">Resumen De Historia Clinica </h5>
                            </div>

                            <div style={{ flexDirection: 'row', display: 'flex', marginTop: 20 }}>

                                <div className="form__form-group" style={{ margin: 10 }}>
                                    <span className="form__form-group-label">Motivo de Consulta</span>

                                    <div className="form__form-group-field">
                                        <textarea
                                            name="textarea-resum-history"
                                            value={this.state.motivo_consulta}
                                            onChange={(e) => { this.setState({ motivo_consulta: e.target.value }) }}
                                            disabled={this.state.disableInput}
                                        >
                                        </textarea>
                                    </div>
                                </div>
                                <div className="form__form-group" style={{ margin: 10 }}>
                                    <span className="form__form-group-label">Encuesta Inventario de Discapacidad por Vértigo (DHI)</span>

                                    <div className="form__form-group-field">
                                        <textarea
                                            name="textarea-resum-history"
                                            value={this.state.encuesta_inventario}
                                            onChange={(e) => { this.setState({ encuesta_inventario: e.target.value }) }}
                                            disabled={this.state.disableInput}
                                        >
                                        </textarea>
                                    </div>
                                </div>
                            </div>
                            <div style={{ flexDirection: 'row', display: 'flex', marginTop: 20 }}>
                                <div className="form__form-group" style={{ margin: 10 }}>
                                    <span className="form__form-group-label">Pruebas de Equilibrio Estatico y Dinámico</span>

                                    <div className="form__form-group-field">
                                        <textarea
                                            name="textarea-resum-history"
                                            value={this.state.pruebas_equilibrio}
                                            onChange={(e) => { this.setState({ pruebas_equilibrio: e.target.value }) }}
                                            disabled={this.state.disableInput}
                                        >
                                        </textarea>
                                    </div>
                                </div>
                                <div className="form__form-group" style={{ margin: 10 }}>
                                    <span className="form__form-group-label">Nistagmo Espontáneo</span>

                                    <div className="form__form-group-field">
                                        <textarea
                                            name="textarea-resum-history"
                                            value={this.state.nistagmo_espontanoeo}
                                            onChange={(e) => { this.setState({ nistagmo_espontanoeo: e.target.value }) }}
                                            disabled={this.state.disableInput}
                                        >
                                        </textarea>
                                    </div>
                                </div>
                            </div>
                            <div style={{ flexDirection: 'row', display: 'flex', marginTop: 20 }}>
                                <div className="form__form-group" style={{ margin: 10 }}>
                                    <span className="form__form-group-label">Test de Agudeza Visual</span>

                                    <div className="form__form-group-field">
                                        <textarea
                                            name="textarea-resum-history"
                                            value={this.state.test_agudeza}
                                            onChange={(e) => { this.setState({ test_agudeza: e.target.value }) }}
                                            disabled={this.state.disableInput}
                                        >
                                        </textarea>
                                    </div>
                                </div>
                                <div className="form__form-group" style={{ margin: 10 }}>
                                    <span className="form__form-group-label">Conclusiones</span>

                                    <div className="form__form-group-field">
                                        <textarea
                                            name="textarea-resum-history"
                                            value={this.state.conclusion}
                                            onChange={(e) => { this.setState({ conclusion: e.target.value }) }}
                                            disabled={this.state.disableInput}
                                        >
                                        </textarea>
                                    </div>
                                </div>
                            </div>

                            <div style={{ flexDirection: 'row', display: 'flex', marginTop: 20 }}>
                            <div className="form__form-group" style={{ margin: 10 }}>
                                    <span className="form__form-group-label">Maniobra Hallpike</span>

                                    <div className="form__form-group-field">
                                        <textarea
                                            name="textarea-resum-history"
                                            value={this.state.maniobra_hallpike}
                                            onChange={(e) => { this.setState({ maniobra_hallpike: e.target.value }) }}
                                            disabled={this.state.disableInput}
                                        >
                                        </textarea>
                                    </div>
                                </div>
                                <div className="form__form-group" style={{ margin: 10 }}>
                                    <span className="form__form-group-label">Recomendaciones</span>
                                    <div className="form__form-group-field">

                                        <textarea
                                            name="textarea-resum-history"
                                            value={this.state.recomendaciones}
                                            onChange={(e) => { this.setState({ recomendaciones: e.target.value }) }}
                                            disabled={this.state.disableInput || !this.state.useRecomentarions}
                                        >
                                        </textarea>
                                    </div>
                                    <FormControlLabel control={<Checkbox name="checkedG" color="primary"

                                        onChange={
                                            (event) => {

                                                if (event.target.checked) {
                                                    this.setState({ useRecomentarions: false,recomendaciones: null});
                                                }
                                                else {
                                                    this.setState({ useRecomentarions: true });
                                                }

                                            }
                                        } />} label="Sin Recomendaciones" />
                                </div>

                            </div>

                            <div>
                                <Button
                                    style={{ marginRight: 12, marginTop: 20 }}
                                    size="sm"
                                    color="primary"
                                    onClick={() => {

                                        if (this.state.exist)
                                            this.generteReportPdf();
                                        else
                                            this.saveData();
                                        ///this.generteReportPdf();
                                    }}
                                >
                                    {this.state.exist ? " Generar Reporte" : " Guardar y Generar Reporte"}

                                </Button>

                                {this.state.exist ?
                                    <Button
                                        style={{ marginTop: 20 }}
                                        size="sm"
                                        color="primary"
                                        onClick={() => {

                                            if (this.state.onUpdate)
                                                this.updateData();
                                            else
                                                this.setState({ disableInput: false, onUpdate: true });
                                        }}
                                    >
                                        {this.state.onUpdate ? "Actualizar" : " Habilitar Actualizacion"}
                                    </Button>
                                    : null}
                            </div>
                        </div>
                    </Fragment>}
            </Card>
        );
    }
}

export default reduxForm({
    form: 'history_form', // a unique identifier for this form
})(withTranslation('common')(HistoryFormFour));